<div class="assets {{data.type}}">
  <ng-container *ngIf="data.type ==='image'">
    <div class="image-container">
      <ng-container *ngFor="let asset of assets; let i = index">
        <smart-image (click)="selectAsset(asset)" *ngIf="i <= 15" class="image"
                         [ngClass]="{'selected': asset.isSelected}" [url]="assetPath + asset.path + '/oneToOne?t='  + timestamp">
        </smart-image>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="data.type ==='media'">
    <ng-container *ngFor="let asset of assets; let i = index">
      <smart-image (click)="selectAsset(asset)" *ngIf="i <= 15" height="96px" type="contain" width="96px"
                       [ngClass]="{'selected': asset.isSelected}" [url]="assetPath + asset.path + '?t='  + timestamp" class="media">
      </smart-image>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="data.type ==='file'">
    <mat-list class="file-table doc">
      <ng-container *ngFor="let asset of assets; let i = index">
        <mat-list-item (click)="selectAsset(asset)" *ngIf="i <= 3" [ngClass]="{'selected': asset.isSelected}">
          <div class="preview">
            <mat-icon>picture_as_pdf</mat-icon>
          </div>
          <div class="name">{{ asset.originalFileName }}</div>
          <div class="created">{{ asset.created | date: 'dd.MM.yyyy - HH:mm' }}</div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </ng-container>

  <ng-container *ngIf="data.type ==='video'">
    <mat-list class="file-table">
      <ng-container *ngFor="let asset of assets; let i = index">
        <mat-list-item (click)="selectAsset(asset)" *ngIf="i <= 3" [ngClass]="{'selected': asset.isSelected}">
          <div class="preview">
            <video height="200px" poster="">
              <source [src]="assetPath + asset.path" [type]="asset.mimeType">
            </video>
            <div class="overlay"></div>
          </div>
          <div class="name">{{ asset.originalFileName }}</div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </ng-container>


  <div class="button-container">
    <div class="row">
      <button (click)="previous()" [disabled]="skip === 0" class="prev" color="primary" mat-icon-button>
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button (click)="next()" [disabled]="count <= (skip + limit[data.type])" class="next" color="primary" mat-icon-button>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
    <div class="row align-right">
      <button (click)="insertAssets()" *ngIf="data.multiple" [disabled]="!selectedAssets || !selectedAssets.length"
              class="ibexfusion-raised-button upload" mat-button>{{ 'general.insert' | translate }}
      </button>
      <button (click)="fileInput.click()" *ifPrivilege="{name: 'write', value: 'assets'}" [disabled]="isUploading"
              class="ibexfusion-raised-button upload" mat-button>
        Upload {{ data.type }}
      </button>
      <input #fileInput (change)="uploadAsset($event)" [accept]="allowedMimetypes" [multiple]="data.type !== 'video'" hidden type="file">
    </div>
  </div>

  <div *ngIf="isUploading" class="progress">
    <div *ngIf="!progress" class="upload-asset {{data.type}}">
      <span>{{ resourceTranslations[data.type === 'video' ? 'videoPreparing' : 'filesUploading'] }}</span>
      <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="!!progress" class="upload-asset {{data.type}}">
      <span>{{ resourceTranslations['videoUploading'] }} {{ progress }}%</span>
      <mat-progress-bar [value]="progress" mode="determinate"></mat-progress-bar>
    </div>
  </div>
</div>
